import React, { useEffect } from "react";
import { Typography, Box, Tooltip, Alert } from "@mui/material";
import { AddressTestingStyles } from "../common/styles/AddressTesting.styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

type Props = {
  address: string;
  name?: string;
  format?: string;
  memo?: string;
  addressAddType?: string;
  refetchAddress: () => void;
};

const AddressSuccess = (props: Props) => {
  const { refetchAddress, addressAddType } = props;
  const classes = AddressTestingStyles();
  //Refetch RTK  Addresses table when closing the success modal.
  useEffect(() => {
    return () => {
      refetchAddress();
    };
  }, []);

  const message =
    addressAddType === "Requested testing withdraw address"
      ? `We received your address and will send a test to your wallet for
  verification. You'll be notified by email and within the portal when the test has been sent.`
      : "Thank you, you have successfully requested the currency addition";

  return (
    <>
      <Alert sx={{ width: "100%", lineHeight: "17px" }} severity="success">
        {message}
      </Alert>
      <Box className={classes.successGroup}>
        <Typography className={classes.successLabel}>Currency</Typography>
        <Typography className={classes.successValue}>{props.name}</Typography>
      </Box>

      <Box className={classes.successGroup}>
        <Typography className={classes.successLabel}>Address</Typography>
        <Typography className={classes.successValue}>{props.address}</Typography>
      </Box>

      <Box className={classes.successGroup}>
        <Typography className={classes.successLabel}>Format</Typography>
        <Typography className={classes.successValue}>{props.format}</Typography>
      </Box>
      {props.memo && (
        <Box className={classes.successGroup}>
          <Box display="flex" alignItems="center">
            <Typography className={classes.successLabel}>Memo</Typography>
            <Tooltip
              classes={{ tooltip: classes.tooltip }}
              placement="top-start"
              title="Missing or incorrect entry of MEMO may cause loss of your assets"
            >
              <InfoOutlinedIcon style={{ marginLeft: "8px", fontSize: "14px" }} />
            </Tooltip>
          </Box>
          <Typography className={classes.successValue}>{props.memo}</Typography>
        </Box>
      )}
    </>
  );
};

export default AddressSuccess;
